<template>
  <el-select
    v-model="signUser"
    placeholder="请选择签署方"
    filterable
    reserve-keyword
    :remote-method="remoteMethod"
    remote
    :loading="loading"
    style="width: 100%"
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { auditCompanyList } from "@/api/auditcenter";
export default {
  props: {
    signUserId: {
      type: String,
      default: "",
    },
    signUserName: {
      type: String,
      default: "",
    },
  },
  watch: {
    signUserName(val) {
        console.log('signUserName',val);
      this.remoteMethod(val);
    },
    signUserId(val) {
      this.signUser = val;
    },
  },
  data() {
    return {
      signUser: "",
      loading: false,
      options: [],
    };
  },
  methods: {
    handleChange(val) {
      const data = this.options.find((item) => item.value === val);
      if (data) {
        this.$emit("changeSignUser", data);
      }
    },
    remoteMethod(query) {
      if (!query) {
        this.options = [];
        return;
      }
      this.loading = true;
      this.loading = false;
      auditCompanyList({
        current: 1,
        size: 100,
        shopTypeCodes: "32,2",
        certifyStatus: 1,
        shopName: query,
        status: -1,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === 0) {
            this.options = res.data.records.map((item) => {
              return {
                label: item.shopName,
                value: item.id,
              };
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.options = [];
        });
    },
    reset() {
      this.signUser = "";
      this.options = [];
    },
  },
};
</script>
